export enum UserType {
    CORPORATE = "CORPORATE",
    CUSTOM = "CUSTOM",
}